export default "__VITE_ASSET__B$yHlvxt__"